/**
 * Colors for selected locations
 */
export const SELECTED_COLORS = [
  '#F46800',
  '#8C1AF4',
  '#B2002A',
  '#F84EBF',
  '#3F00B3',
  '#FF0C0C'
]



/**
 * colors for map choropleths
 */
export const CHOROPLETH_COLORS = [
  '#174b80',
  '#4189d2',
  '#abd9e9',
  '#f7f7f7',
  '#bfe9ab',
  '#2fb57f',
  '#136e4a'
]

/**
 * Color for areas on the map with no data
 */
export const NO_DATA_COLOR = '#ccc'

/**
 * Color for location markers for an inactive region (e.g. counties when districts are selected)
 */
export const INACTIVE_COLOR = '#ccc'
